import { render, staticRenderFns } from "./HeaderControlsReport.vue?vue&type=template&id=42bd70ad&scoped=true&"
import script from "./HeaderControlsReport.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsReport.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsReport.vue?vue&type=style&index=0&id=42bd70ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bd70ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bd70ad')) {
      api.createRecord('42bd70ad', component.options)
    } else {
      api.reload('42bd70ad', component.options)
    }
    module.hot.accept("./HeaderControlsReport.vue?vue&type=template&id=42bd70ad&scoped=true&", function () {
      api.rerender('42bd70ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControlsReport.vue"
export default component.exports